import { useEffect, useState } from "react";
import api from "../lib/api";
import BrandHeader from "../components/brand/BrandHeader";
import Footer from "../components/brand/Footer";
import MerchantCard from "../components/brand/MerchantCard";

export default function MerchantList() {
  const [merchants, setMerchants] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCat, setActiveCat] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/merchants", { params: { ...(activeCat ? { category_id: activeCat } : {}), ...(q ? { q } : {}) } })
      .then(({ data }) => setMerchants(data));
  }, [activeCat, q]);

  useEffect(() => { api.get("/categories").then(({ data }) => setCategories(data)); }, []);

  return (
    <div className="min-h-screen bg-[#050505]">
      <BrandHeader />
      <section className="max-w-7xl mx-auto px-6 py-12">
        <div className="mb-10">
          <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">Partner Venues</p>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl text-white">Curated Partners</h1>
          <p className="text-white/60 mt-3 max-w-2xl">Bars, restaurants, lounges, and clubs hand-picked into The Social Circle.</p>
        </div>

        <div className="flex flex-col md:flex-row gap-4 mb-8">
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name…" className="tsc-input md:max-w-sm" data-testid="merchant-search" />
          <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
            <button onClick={() => setActiveCat(null)}
              className={`text-[10px] tracking-luxe uppercase px-4 py-2 rounded-full border whitespace-nowrap transition-colors ${activeCat === null ? "bg-[#D4AF37] text-black border-[#D4AF37]" : "border-white/15 text-white/70"}`}>All</button>
            {categories.map((c) => (
              <button key={c.id} onClick={() => setActiveCat(c.id)}
                className={`text-[10px] tracking-luxe uppercase px-4 py-2 rounded-full border whitespace-nowrap transition-colors ${activeCat === c.id ? "bg-[#D4AF37] text-black border-[#D4AF37]" : "border-white/15 text-white/70"}`}>{c.name}</button>
            ))}
          </div>
        </div>

        {merchants.length === 0 ? (
          <div className="text-center py-20 border border-white/5 rounded-md" data-testid="no-merchants-page">
            <p className="text-white/50 italic">No venues match your filters.</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {merchants.map((m) => <MerchantCard key={m.id} merchant={m} />)}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
